/** Textos de interfaz para gestión de usuario (controles, formularios) */
export const handleUserStrings = {
  formSectionTitle: "Datos del usuario",
  formSubmit: "Guardar usuario",
  fieldFirstName: "Nombre",
  fieldLastName: "Apellidos",
  fieldEmail: "Correo electrónico",
  fieldPhone: "Teléfono personal",
  fieldPhoneJob: "Teléfono laboral (opcional)",
  fieldDocument: "Documento de identidad (opcional)",
  fieldCity: "Ciudad (opcional)",
  fieldPassword: "Contraseña",
  fieldPasswordHelper:
    "Opcional. Déjela vacía para usar el correo de primer acceso.",
  fieldLevel: "Nivel de rol",
  fieldPercentage: "Porcentaje",
  levelAdmin: "Administrador",
  levelSubAdmin: "Subadministrador",
  levelMainLead: "Lead principal",
  levelLead: "Lead",
  levelVentor: "Ventas",
  levelOffice: "Oficina",
  levelFinance: "Finanzas",
  levelSecretary: "Secretaría",
  levelContent: "Contenido",
  levelExternalAgent: "Agente externo",
  validationTitle: "Revise el formulario",
  validationRequiredFields:
    "El nombre, apellidos, correo, teléfono y nivel son obligatorios.",
  validationOfficeRequired: "Seleccione una oficina para este nivel de rol.",
  errorCreateUserTitle: "Error al crear el usuario",
  errorUpdateUserTitle: "Error al actualizar el usuario",
  ctrlEnable: "Activar",
  ctrlPhysical: "Usuario físico",
  ctrlOnLand: "En terreno",
  ctrlReceiveCustomersAuto: "Recibir clientes automáticamente",
  ctrlAssignAdvanceLeads: "Asignar Leads Calificados",
  sendWelcomeAccess: "Enviar correo de primer acceso",
  sendWelcomeAccessSuccessTitle: "Correo enviado",
  sendWelcomeAccessSuccessBody:
    "Se ha enviado al usuario el correo de bienvenida con el enlace de acceso.",
  sendWelcomeAccessError: "No se pudo enviar el correo de bienvenida",
  sendContract: "Enviar contrato",
  sendContractSuccessTitle: "Contrato procesado",
  sendContractSuccessBody:
    "Se generó el contrato. El usuario recibirá el enlace de firma por correo cuando el envío de correo esté configurado.",
  sendContractSuccessOk: "Aceptar",
  sendContractError: "No se pudo generar ni enviar el contrato",
  sendContractMissingTitle: "Falta información para el contrato",
  sendContractMissingIntro:
    "Complete lo siguiente en el formulario de datos del usuario, guarde el usuario si es necesario e inténtelo de nuevo:",
  sendContractMissingNoUser: "El perfil del usuario no está cargado",
  sendContractMissingSavedUser:
    "El usuario debe guardarse primero (solo usuarios existentes)",
  sendContractMissingFullName: "Nombre y apellidos",
  sendContractMissingDocument: "Documento de identidad",
  sendContractMissingEmail: "Correo electrónico",
  sendContractMissingPhone: "Teléfono personal",
  sendContractMissingCity: "Ciudad",
  sendContractMissingClose: "Cerrar",
}
